import React, { useState, useEffect } from "react";
import { FaServer, FaFolder, FaRobot, FaCogs } from 'react-icons/fa';
import config from '../../config/config';
import { toast } from 'react-toastify';
import axios from "axios";
import "../../styles/Orchestrator.css";
import { useTenant } from "../../context/TenantContext";

const Orchestrator = () => {
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [folders, setFolders] = useState([]); // Changed from {} to []
  const [robots, setRobots] = useState([]); // Changed from {} to []
  const [processes, setProcesses] = useState([]); // Changed from {} to []
  const { tenants, fetchTenants } = useTenant();

  useEffect(() => {
    if (fetchTenants) {
      fetchTenants();
    }
  }, [fetchTenants]);

  const handleTenantClick = async (tenant) => {
    // Clear all previous data when selecting a new tenant
    setSelectedTenant(tenant);
    setSelectedFolder(null);
    setFolders([]);
    setRobots([]);
    setProcesses([]);

    try {
      const token = localStorage.getItem("userToken");
      const storedTenant = JSON.parse(localStorage.getItem("selectedTenant"));
      
      console.log("Fetching folders for tenant:", tenant);
      const response = await axios.get(`${config.API_BASE_URL}/api/orchestrator/folders/tenant/${tenant.id}`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'selected-tenant': JSON.stringify(storedTenant),
          'X-UIPATH-OrganizationUnitId': tenant.orch_tenant_id.toString()
        },
      });

      if (response.data && response.data.folders) {
        console.log("Received folders:", response.data.folders);
        setFolders(response.data.folders);
      } else {
        console.log("No folders in response:", response.data);
        setFolders([]);
      }
    } catch (error) {
      console.error("Error details:", error.response || error);
      toast.error("Error fetching folders: " + (error.response?.data?.message || error.message));
      setFolders([]);
    }
  };

  const handleFolderClick = async (folder) => {
    setSelectedFolder(folder);
    // Clear previous data when selecting a new folder
    setRobots([]);
    setProcesses([]);

    try {
      const token = localStorage.getItem("userToken");
      const storedTenant = JSON.parse(localStorage.getItem("selectedTenant"));

      console.log("Fetching data for folder:", folder);

      try {
        const robotsRes = await axios.get(`${config.API_BASE_URL}/api/orchestrator/robots/${folder.id}`, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'selected-tenant': JSON.stringify(storedTenant),
            'X-UIPATH-OrganizationUnitId': selectedTenant.orch_tenant_id.toString()
          },
        });
        setRobots(robotsRes.data.robots || []);
      } catch (robotError) {
        console.error("Error fetching robots:", robotError);
        setRobots([]);
      }

      try {
        const processesRes = await axios.get(`${config.API_BASE_URL}/api/orchestrator/releases/${folder.id}`, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'selected-tenant': JSON.stringify(storedTenant),
            'X-UIPATH-OrganizationUnitId': selectedTenant.orch_tenant_id.toString()
          },
        });
        setProcesses(processesRes.data.releases || []);
      } catch (processError) {
        console.error("Error fetching processes:", processError);
        setProcesses([]);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching data. Please try again later.");
      setRobots([]);
      setProcesses([]);
    }
  };

  return (
    <div className="orchestrator-container">
      <h2>Orchestrator Configuration</h2>
      <div className="orchestrator-grid">
        <div className="section">
          <h3><FaServer /> Tenants</h3>
          <div className="list">
            {tenants.map(tenant => (
              <div 
                key={tenant.id} 
                className={`item ${selectedTenant?.id === tenant.id ? 'selected' : ''}`}
                onClick={() => handleTenantClick(tenant)}
              >
                {tenant.name}
              </div>
            ))}
          </div>
        </div>

        <div className="section">
          <h3><FaFolder /> Folders</h3>
          <div className="list">
            {!selectedTenant ? (
              <div className="item empty-state">Please select a tenant first</div>
            ) : folders.length > 0 ? (
              folders.map(folder => (
                <div 
                  key={folder.id} 
                  className={`item ${selectedFolder?.id === folder.id ? 'selected' : ''}`}
                  onClick={() => handleFolderClick(folder)}
                >
                  {folder.name}
                </div>
              ))
            ) : (
              <div className="item empty-state">No folders available</div>
            )}
          </div>
        </div>

        <div className="bottom-sections">
          <div className="section">
            <h3><FaRobot /> Robots</h3>
            <div className="list">
              {!selectedFolder ? (
                <div className="item empty-state">Please select a folder first</div>
              ) : robots && robots.length > 0 ? (
                robots.map(robot => (
                  <div key={robot.Id} className="item">
                    {robot.Name || robot.MachineName}
                  </div>
                ))
              ) : (
                <div className="item empty-state">No robots available for this folder</div>
              )}
            </div>
          </div>

          <div className="section">
            <h3><FaCogs /> Processes</h3>
            <div className="list">
              {!selectedFolder ? (
                <div className="item empty-state">Please select a folder first</div>
              ) : processes && processes.length > 0 ? (
                processes.map(process => (
                  <div key={process.Key} className="item">
                    {process.ProcessKey || process.Name}
                  </div>
                ))
              ) : (
                <div className="item empty-state">No processes available for this folder</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orchestrator;

